import { Divider, Grid, Group, Skeleton, Space, Text } from '@mantine/core';
import XInfoTabTitle from '../../x-components/x-info-tab-title.component';
import XSkeleton1Fields from '../../x-components/x-skeletons/x-skeleton-1-fields.component';
import XSkeleton2Fields from '../../x-components/x-skeletons/x-skeleton-2-fields.component';
import XSkeleton3Fields from '../../x-components/x-skeletons/x-skeleton-3-fields.component';
import XSkeleton4Fields from '../../x-components/x-skeletons/x-skeleton-4-fields.component';

function SkeletonMerchantInfoGeneral(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';

  return (
    <>
      <Group grow>
        <XInfoTabTitle
          label='General Information'
          dataCy='generalInformationTitle'
        />
      </Group>
      <Space h='xl' />
      <Grid>
        <XSkeleton4Fields />
        <XSkeleton4Fields />
        <XSkeleton4Fields />
        <XSkeleton1Fields />
      </Grid>

      <Divider my='xl' />

      <Text size='xl' weight={700}>
        Main Office Contact Information
      </Text>
      <Space h='xl' />

      <Grid>
        <XSkeleton4Fields />
        <XSkeleton3Fields />
      </Grid>
      <Divider my='xl' />

      <Text size='xl' weight={700}>
        Websites
      </Text>
      <Grid>
        <XSkeleton2Fields />
        <XSkeleton4Fields />
      </Grid>

      <Divider my='xl' />

      <Space h='xl' />

      <Grid>
        <Grid.Col>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
        <Grid.Col>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
        <Grid.Col>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
      </Grid>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

const labels = {
  businessType: 'Business type',

  merchantName: 'Company name',
  merchantBusinessName: 'Registered business name',
  businessHandle: 'Name for payment link',
  merchantCompanyTin: 'Company TIN',

  mainOfficeContactNumber: 'Main office contact number',
  mainOfficeBldgNameNo: 'Main office building name and number',
  mainOfficeStreetAddress: 'Main office street address',
  mainOfficeBarangay: 'Main office barangay',
  mainOfficeCity: 'Main office city',
  mainOfficeProvince: 'Main office province',
  mainOfficePostalCode: 'Main office postal code',

  registeredContactNumber: 'Registered contact number',
  registeredBldgNameNo: 'Registered building name and number',
  registeredStreetAddress: 'Registered street address',
  registeredBarangay: 'Registered barangay',
  registeredCity: 'Registered city',
  registeredProvince: 'Registered province',
  registeredPostalCode: 'Registered postal code',

  isBrickAndMortarStore: 'Do you have a physical store?',
  industry: 'Industry',
  serviceDescription: 'Service description',
  modeOfPayment: 'Mode of Payment/s',
  currency: 'Currency',
};

export default SkeletonMerchantInfoGeneral;
